import { FaCartArrowDown } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { cartActions } from "../../redux/slices/cartSlice";
import React, { memo } from "react";
import axiosClient from "../../axios-client";
import { Badge, IconButton, styled } from "@mui/material";
import { toast } from "react-toastify";
// import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
export const getMyCartItems = async (userId, dispatch) => {
  if (!userId) {
    return;
  }
  try {
    const response = await axiosClient.get(`item/getCartItem/${userId}`);
    if (response.status === 200) {
      dispatch(cartActions.setMyCartItems(response.data.cartList));
    }
  } catch (error) {
    console.log(error, "Error fetching cart items");
  }
};
export const MyCart = memo(() => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const myCartItems = useSelector((state) => state.cart.myCartItems);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { headerCounts } = useSelector((state) => state.user);
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );
  const hasFetchedCart = React.useRef(false);

  // React.useEffect(() => {
  //   if (islogin && user && !hasFetchedCart.current) {
  //     getMyCartItems(user.UserID, dispatch);
  //     hasFetchedCart.current = true;
  //   }
  // }, [islogin, user]);

  const handleCartClick = () => {
    if (!islogin) {
      toast.error("Please login to view your cart");
      navigate("/login");
      return;
    }
    if (!isProfileComplete) {
      toast.error("Please complete your profile before accessing the cart");
      return;
    }
    navigate("/dashboardpage/orders?tab=items-in-cart");
  };
  const StyledBadge = styled(Badge)(({ theme }) => ({
    "& .MuiBadge-badge": {
      right: -3,
      top: 1,
      border: `2px solid ${theme.palette.background.paper}`,
      backgroundColor: "var(--button-bg)",
      padding: "0 4px",
    },
  }));
  return (
    <IconButton aria-label="cart" onClick={handleCartClick}>
      <StyledBadge
        badgeContent={headerCounts.cartCount || ""}
        color="secondary"
        showZero
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <FaCartArrowDown size={25} className="cart-icon" />
      </StyledBadge>
    </IconButton>
  );
});

MyCart.displayName = "MyCart";
